<div class="flex flex-wrap -mx-2">
    <div class="w-full sm:flex-none sm:w-full px-2">
        <mat-checkbox
            [(ngModel)]="joblevelSelectAll"
            (change)="onChangeJobLevel()"
            [disabled]="disabled"
        >{{joblevelSelectAll ? 'Select None' : 'Select All'}}</mat-checkbox>
    </div>
</div>
<div class="flex flex-wrap -mx-2 ml-1">
    <div class="w-full sm:flex-none sm:w-full pt-1 px-2" *ngFor="let jobLevel of jobLevelData">
        <mat-checkbox
            [value]="jobLevel"
            [(ngModel)]="jobLevels[jobLevel.key]"
            (change)="onChangeJobLevelKey(jobLevels[jobLevel.key])"
            [disabled]="disabled"
        >{{ Labels[jobLevel.key] }}</mat-checkbox>
    </div>
</div>
